import { createContext } from 'preact'

export const StoreCtx = createContext({})
export const ApiCtx = createContext({})
